module.exports = __webpack_public_path__ + "img/cloudpod_logo.ae32a0d8.svg";